import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {PullRequestErrorState} from '../components/PullRequestErrorState'
import {DiffComparisonViewer} from '../components/DiffComparisonViewer'
import {Suspense} from 'react'
import {pullRequestsFilesRoute, pullRequestsFilesWithRangeRoute} from './files-route'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsLayoutRoute} from './layout-route'
import type {PullRequest} from '../types'
import type {FilesRoutePayload} from './route-payload-types'

export function FilesEntrypointFuture() {
  return (
    <ErrorBoundary critical fallback={<PullRequestErrorState text="Changes cannot be loaded" />}>
      <Files />
    </ErrorBoundary>
  )
}

export function FilesWithRangeEntrypointFuture() {
  return (
    <ErrorBoundary critical fallback={<PullRequestErrorState text="Changes cannot be loaded" />}>
      <FilesWithRange />
    </ErrorBoundary>
  )
}

function Files() {
  const {
    data: {pullRequest},
  } = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  const {data: routeData} = useRouteQuery(pullRequestsFilesRoute, 'mainQuery')

  return <FilesComponent pullRequest={pullRequest} routeData={routeData} />
}

function FilesWithRange() {
  const {
    data: {pullRequest},
  } = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  const {data: routeData} = useRouteQuery(pullRequestsFilesWithRangeRoute, 'mainQuery')

  return <FilesComponent pullRequest={pullRequest} routeData={routeData} />
}

function FilesComponent({pullRequest, routeData}: {pullRequest: PullRequest; routeData: FilesRoutePayload}) {
  return (
    <Suspense>
      <DiffComparisonViewer.Viewer
        basePath={pullRequest.pathName}
        initialData={routeData}
        useAdvancedToolbar
        useChangeGroups
        useInlineComments
        useEditOptions
        useFileTree
      />
    </Suspense>
  )
}

try{ FilesEntrypointFuture.displayName ||= 'FilesEntrypointFuture' } catch {}
try{ FilesWithRangeEntrypointFuture.displayName ||= 'FilesWithRangeEntrypointFuture' } catch {}
try{ Files.displayName ||= 'Files' } catch {}
try{ FilesWithRange.displayName ||= 'FilesWithRange' } catch {}
try{ FilesComponent.displayName ||= 'FilesComponent' } catch {}